__webpack_require__.p = "/BoomiAI/boomi-ai-ui/";